module.exports = __webpack_public_path__ + "media/aangezicht.d4111306.mp4";